import {
  Questionnaire,
  Question,
  Section,
} from "../../../pages/ProjectSurveysV2/types";
import { Form, Col } from "react-bootstrap";
import buildInputElement from "./buildInputElement";

interface FormProps {
  questionnaire: Questionnaire;
  questions: Question[];
  setQuestions: (questions: Question[]) => void;
  sections: Section[];
  newSectionRef?: React.RefObject<HTMLDivElement>;
}

const QuestionnaireForm = ({
  questionnaire,
  questions,
  setQuestions,
  sections,
  newSectionRef,
}: FormProps) => {
  const showSections =
    questionnaire?.sections?.length &&
    (questionnaire?.sections?.length > 1 ||
      questionnaire?.sections?.[0]?.name !== questionnaire.name);

  return (
    <>
      {questionnaire?.introduction && (
        <div className="aboutSurvey">
          <h5>About this survey</h5>
          <div className="introduction">{questionnaire.introduction}</div>
        </div>
      )}
      {questions?.length ? (
        <Form>
          {showSections ? (
            sections
              ?.filter((section) => !section.expression || section.show)
              ?.map((section, i) => {
                const isLastVisible =
                  sections.filter((s) => s.show).at(-1)?.id === section.id;
                return (
                  <div
                    className="questionnaireSection"
                    key={i}
                    ref={isLastVisible && newSectionRef ? newSectionRef : null}
                  >
                    <div className="sectionHeader">
                      <h5>{section.name}</h5>
                      {section?.introduction && (
                        <div className="introduction">
                          {section.introduction}
                        </div>
                      )}
                    </div>
                    <div className="questionsContainer" key={i}>
                      {questions
                        ?.filter(
                          (q) => q?.["questionnaire-section-id"] == section.id
                        )
                        ?.map((q) => (
                          <Col
                            key={String(q?.["question-id"])}
                            xs={6}
                            className="surveyQuestion"
                          >
                            {buildInputElement(q, questions, setQuestions)}
                          </Col>
                        ))}
                    </div>
                  </div>
                );
              })
          ) : (
            <div>
              <div
                style={{
                  marginBottom: "10px",
                  fontSize: "16px",
                  color: "#1c2655",
                }}
              >
                Survey Details
              </div>
              <div className="questionsContainer">
                {(questions || [])?.map((q) => (
                  <Col
                    key={String(q?.["question-id"])}
                    xs={6}
                    className="surveyQuestion"
                  >
                    {buildInputElement(q, questions, setQuestions)}
                  </Col>
                ))}
              </div>
            </div>
          )}
        </Form>
      ) : (
        "There are no questions on this survey. Please configure in settings"
      )}
    </>
  );
};

export default QuestionnaireForm;
